import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICountry } from "src/models/General/Country.models";

interface CountryState {
  countries: ICountry[];
  countryToEdit: ICountry | null;
}

const initialState: CountryState = {
  countries: [],
  countryToEdit: null,
};

const countrySlice = createSlice({
  name: "Country",
  initialState,
  reducers: {
    setCountryList: (state, action: PayloadAction<ICountry[]>) => {
      state.countries = action.payload;
    },
    concatListCountry: (
      state: CountryState,
      action: PayloadAction<ICountry[]>
    ) => {
      state.countries = [...state.countries.concat(action.payload)];
    },
    setCountryToEdit: (state, action: PayloadAction<ICountry | null>) => {
      state.countryToEdit = action.payload;
    },
    addCountry: (state, action: PayloadAction<ICountry>) => {
      state.countries.push(action.payload);
    },
    updateCountry: (state, action: PayloadAction<ICountry>) => {
      let itemIndex = state.countries.findIndex(
        item => item.countryId === action.payload.countryId
      );
      if (itemIndex !== -1) state.countries[itemIndex] = action.payload;
    },
    deleteCountry: (state, action: PayloadAction<number>) => {
      const newArray = state.countries.filter(
        item => item.countryId !== action.payload
      );
      state.countries = newArray;
    },
  },
});

export const {
  setCountryList,
  concatListCountry,
  setCountryToEdit,
  addCountry,
  updateCountry,
  deleteCountry,
} = countrySlice.actions;

export default countrySlice.reducer;
